import React, { Component, Fragment } from 'react';
import common from 'ui-react-common';

const InputField = common.ui.components.forms.InputField;

export const validation = {
    validateOn: ['blur'],
    validationRegex: /^\d{4}$/,
    required: true,
    message: {
        default: 'Please enter a valid last 4 of your social security number',
    },
};

class SSNLast4 extends Component {
    render() {
        return (
            <Fragment>
                <InputField
                    id="ssnLast4"
                    name="ssnLast4"
                    type="password"
                    placeholder="Last 4 of SSN"
                    validation={validation}
                    value={this.props.value}
                    mask="9999"
                    maskChar=" "
                />
                <span className="small">
          We use 256-bit SSL encryption and strict, high levels of security to
          keep your information safe.
                </span>
            </Fragment>
        );
    }
}

export default SSNLast4;
